div.core-focus-trap {
	height: 0;
	width: 0;
	overflow: hidden;
	position: absolute;
}
